import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { fa } from "app/main/std";

type Entity = models.BitacoraRADStatusDto;
type Column = kea.Grid2Column<Entity>;

export const columnas: Column[] = [
    { title: "Fecha", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Status", cell: x => ({ data: models.StatusBitacoraRad[x.Status] }) },
    { title: "Usuario", cell: x => ({ data: x.Usuario.Nombre }) },
    { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
];


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/status/columns.tsx